export default __webpack_public_path__ + "static/media/instructor-7.3fb5c9f2.jpg";